window.changeResultsChart = function() {
    thermometer_id = $('#thermometer_id').val();
    pattern_measure_1 = $('#pattern_measure_1').val();
    instrument_measure_1 = $('#instrument_measure_1').val();
    pattern_measure_2 = $('#pattern_measure_2').val();
    instrument_measure_2 = $('#instrument_measure_2').val();
    pattern_measure_3 = $('#pattern_measure_3').val();
    instrument_measure_3 = $('#instrument_measure_3').val();
    pattern_measure_4 = $('#pattern_measure_4').val();
    instrument_measure_4 = $('#instrument_measure_4').val();
    pattern_measure_5 = $('#pattern_measure_5').val();
    instrument_measure_5 = $('#instrument_measure_5').val();
    $.ajax({
        url: '/factory/equipment/thermometer_contrasts/get_results_chart',
        type: 'POST',
        data:{
            thermometer_contrast: {
                pattern_measure_1: pattern_measure_1, instrument_measure_1: instrument_measure_1,
                pattern_measure_2: pattern_measure_2, instrument_measure_2: instrument_measure_2,
                pattern_measure_3: pattern_measure_3, instrument_measure_3: instrument_measure_3,
                pattern_measure_4: pattern_measure_4, instrument_measure_4: instrument_measure_4,
                pattern_measure_5: pattern_measure_5, instrument_measure_5: instrument_measure_5,
                thermometer_id: thermometer_id
            }
        }
    }).done(function(e) {

    });  

}

window.showResultsChart = function() {
    $('#measure_and_results').removeAttr('hidden');
    $('#pattern_error_box').removeAttr('hidden');
    $('#pattern_error_title').removeAttr('hidden');
    $('#save_button_box').removeAttr('hidden');
    $('#continue_button_box').attr('hidden','true');
} 